import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.initializeTooltips();
  }

  initializeTooltips() {
    // Remove stray tooltip elements from DOM
    document.querySelectorAll(".tooltip").forEach(el => el.remove());

    // Bootstrap 4 tooltip initialization
    $(this.element).find('[data-toggle="tooltip"]').tooltip();
  }
}
